<template>
    <div class="layer-contents">
        <div class="layer-img media-wrap">
            <!-- 우측 미디어 박스 -->
            <right-image-view 
                :main-url="isInitMedia?viewMedia.image_full:activeGroupMediaSrc"
                :sub-url="isInitMedia?viewMedia.image_medium:activeGroupMediaSrc"
            ></right-image-view>

            <!-- 팝업 좌측 -->
            <div class="media-explanation">
                <!-- 좌상단 정보(로딩중) -->
                <div class="explanation-head" v-if="isDataLoading">
                    <div class="clearfix"><span class="btn-label">이미지</span></div>
                    <h1><span class="skeleton-box" style="width:360px;">&nbsp;</span></h1>
                    <div class="data-info">
                        <p class="asset-data-desc">
                            <span class="skeleton-box" style="width:100%;">&nbsp;</span>
                            <span class="skeleton-box" style="width:60%;">&nbsp;</span>
                        </p>
                        <ul class="asset-data-meta">
                            <li><span class="skeleton-box" style="width:300px;">&nbsp;</span></li>
                        </ul>
                    </div>
                </div>
                <!-- 좌상단 정보 -->
                <div v-else 
                    ref="wrap"
                    class="explanation-head"
                    style="max-height: 50vh;"
                >
                    <div class="clearfix"><span class="btn-label">이미지</span></div>
                    <h1>{{ isInitMedia?viewMedia.title:"이야기자료 연관 이미지 목록" }}</h1>
                    <div class="data-info" v-if="isInitMedia">
                        <p class="asset-data-desc" v-html="viewMedia.description"></p>
                        <ul class="asset-data-meta">
                            <li>{{viewMedia.theme_name}} &gt; {{viewMedia.child_theme_name}}</li>
                            <li class="bar">{{viewMedia.major_category_name}} &gt; {{viewMedia.minor_category_name}}</li>
                            <li class="bar" v-if="viewMedia.copyright != '한국문화원연합회'">{{viewMedia.copyright}}</li>
                        </ul>
                    </div>
                    <div class="data-info" v-else>
                        <p class="asset-data-desc">{{ `${initData.story_info.title} 관련 이미지들` }}</p>
                        <ul class="asset-data-meta">
                            <li>시청각물 > 사진</li>
                            <li class="bar">한국문화원연합회</li>
                        </ul>
                    </div>
                </div>

                <div class="explanation-body">
                    <!-- 로딩중 목록 -->
                    <div class="tabContent active" v-if="isDataLoading">
                        <div id="group_media_list">
                            <vue-custom-scrollbar class="ps" style="max-height: 100%;">
                                <ul class="list" >
                                    <group-media-item-loading
                                        v-for="i in initData.image_list.length"
                                        :key="i"
                                    ></group-media-item-loading>
                                </ul>
                            </vue-custom-scrollbar>
                        </div>
                    </div>
                    <!-- 로딩완료 목록 -->
                    <div class="tabContent active" v-else>
                        <div id="group_media_list"
                            v-if="explanationHeadHeight>0"
                            :style="isMobileMode?'height: auto;':`height: calc(100vh - ${295+explanationHeadHeight}px);`"
                        >
                            <vue-custom-scrollbar class="ps" style="max-height: 100%;">
                                <!-- 목록(정상) -->
                                <ul class="list" v-if="isInitMedia">
                                    <group-media-item
                                        v-for="m in groupMediaList"
                                        :key="m.id"
                                        :media="m"
                                        :view-media-id="activeGroupMediaId"
                                        @select-media="selectMedia"
                                    ></group-media-item>
                                </ul>
                                <!-- 목록(실패) -->
                                <ul class="list" v-else>
                                    <group-media-item-empty
                                        v-for="(src, i) in initData.image_list"
                                        :key="i"
                                        :index="i"
                                        :imgSrc="src"
                                        :activeSrc="activeGroupMediaSrc"
                                        @select-media-empty="selectMediaEmpty"
                                    ></group-media-item-empty>
                                </ul>
                            </vue-custom-scrollbar>
                        </div>
                    </div>
                </div>
            </div>
        </div><!-- //media-wrap -->
        
    </div><!-- //layer-contents -->
</template>

<script>
import VueCustomScrollbar from 'vue-custom-scrollbar'; // 스크롤바 옵션 https://binaryify.github.io/vue-custom-scrollbar/en/#options
import RightImageView from './RightBox/ImageView.vue';
import GroupMediaItemLoading from './GroupMediaItem.skeleton.vue';
import GroupMediaItem from './GroupImage4StoryItem.vue';
import GroupMediaItemEmpty from './GroupImageItemEmpty.vue';

// import sampleData from '../../../json/StoryView_472_Images.json'; // [SAMPLE]

export default {
    components: {
        VueCustomScrollbar, // 커스텀 스크롤바 // <vue-custom-scrollbar>
        RightImageView, // 우측 이미지 뷰어 // <right-image-view>
        GroupMediaItemLoading, // 연관이미지 로딩중 // <group-media-item-loading>
        GroupMediaItem, // 연관 이미지 // <group-media-item>
        GroupMediaItemEmpty, // 연관 이미지 (통신실패) // <group-media-item-empty>
    },
    props: {
        initData: { type: Object, require: true, }, // 선택된 미디어
    },
    data() {
        return {
            isDataLoading: true,
            viewMedia: null, // 상세히 볼 미디어
            groupMediaList: [],
            activeGroupMediaId: 0,
            activeGroupMediaSrc: "",
            explanationHeadHeight: 0,
            isMobileMode: false, // 접속이 모바일인지?
        }
    },
    computed:{
        isInitMedia(){ return this.isNotEmpty(this.viewMedia); }, // 한번만 판단하자
        // 썸네일 주소
        mediaThumbnailUrl(){
            if( this.isEmpty(this.viewMedia) ) return 'https://via.placeholder.com/800x535';
            if( this.isNotEmpty(this.viewMedia.thumbnail2) ){
                return this.viewMedia.thumbnail2;
            } // 없으면...
            return this.viewMedia.thumbnail_url;
            // return 'https://via.placeholder.com/800x535'; 
        }
    },
    created(){
        // console.log(this.initData);
        this.activeGroupMediaSrc = this.initData.image_src;
        this.getData();
        const docWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        this.isMobileMode = docWidth<640;
    },
    mounted(){
        this.checkHeight(50);
    },
    methods: {
        // 주기적으로 반복해서 정보박스 높이 측정 // TODO 모바일의 경우
        checkHeight(interval){
            setTimeout(e=>{
                if( this.isNotEmptyProp(this.$refs, 'wrap') && this.$refs.wrap.clientHeight > 10 ){
                    this.explanationHeadHeight = this.$refs.wrap.clientHeight;
                } else {
                    this.checkHeight(50);
                }
            }, interval);
        },
        // 다른 미디어 선택시
        selectMedia(selectMediaId) {
            for (const m of this.groupMediaList) {
                if( m.id == selectMediaId ){
                    this.viewMedia = m;
                    this.activeGroupMediaId = m.id
                }
            }
        },
        // 데이터 로드 실패시
        selectMediaEmpty(selectImageSrc) {
            this.activeGroupMediaSrc = selectImageSrc;
        },
        // 데이터 통신
        getData(){
            const url = `/api/v1/story/${this.initData.story_info.id}/multimedia/content`;
            axios.get( url ).then(({data}) => {
                // console.log(data); // TODO 데이터 모자랄때는???
                // data = sampleData; // [SAMPLE]
                if( this.isNotEmpty(data) && data.count>0 ){
                    this.groupMediaList = data.media_list;
                    for (const m of data.media_list) {
                        if( m.thumbnail == this.initData.image_src
                            || m.image_full == this.initData.image_src
                            || m.image_medium == this.initData.image_src
                        ){ // (썸네일/풀/미디엄) 주소가 일치하는 친구로 초기화
                            this.viewMedia = m;
                            this.activeGroupMediaId = m.id;
                        }
                    }
                    // 만약 못찼으면 그냥 1번째꺼 사용
                    if( this.isEmpty(this.viewMedia) ){
                        this.viewMedia = data.media_list[0];
                        this.activeGroupMediaId = data.media_list[0].id;
                    }
                }
            }).catch(err => {
                console.log(err);
            }).finally(()=>{
                this.isDataLoading = false;
            });
        }
    }
}
</script>